import DigitalOrdersList from './digitalOrdersList';
import DigitalOrdersShow from './digitalOrdersShow';
import DigitalOrdersEdit from './digitalOrdersEdit';

export default {
    list: DigitalOrdersList,
    edit: DigitalOrdersEdit,
    show: DigitalOrdersShow,
};
